/**
 * Tokens CSS utilizados pela tabela.
 * Centralizam variáveis customizadas para controle de layout e estilo.
 */
export const TABLE_TOKENS = {
  /**
   * Define o template de colunas aplicado ao grid.
   */
  COLUMN_WIDTHS: '--br-table-column-widths',

  /**
   * Controla o espaçamento interno das células.
   */
  DENSITY: '--br-table-density',

  /**
   * Define o alinhamento horizontal do conteúdo das células.
   */
  HORIZONTAL_ALIGNMENT: '--br-table-horizontal-alignment',

  /**
   * Define o alinhamento vertical do conteúdo das células.
   */
  VERTICAL_ALIGNMENT: '--br-table-vertical-alignment',

  /**
   * Define o estilo visual das linhas divisórias.
   */
  DIVIDER_STYLE: '--br-table-divider-style',

  /**
   * Controla a visibilidade/intensidade do divisor entre colunas.
   */
  COLUMN_DIVIDER_FACTOR: '--br-table-column-divider-factor',

  /**
   * Controla a visibilidade/intensidade do divisor entre linhas.
   */
  ROW_DIVIDER_FACTOR: '--br-table-row-divider-factor',

  /**
   * Controla o comportamento de overflow do conteúdo das células.
   */
  CELL_OVERFLOW: '--br-table-cell-overflow',

  /**
   * Controla o comportamento de overflow de texto dentro das células.
   */
  CELL_TEXT_OVERFLOW: '--br-table-cell-text-overflow',

  /**
   * Controla o comportamento de quebra de linha dentro das células.
   */
  CELL_WHITE_SPACE: '--br-table-cell-white-space',
} as const
